import * as React from 'react';

import {
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    useTheme,
} from '@mui/material';

import { ReminderPublisherApiObject } from '@europrocurement/l2d-domain';
import { Accordion } from '@europrocurement/flexy-components';
import { FaOptionIcon, sendIcon } from '@europrocurement/l2d-icons';

/**
 * Props for ReminderHistory component
 */
type ReminderHistoryProps = {
    /** Data source for invoices */
    reminderPublisher?: ReminderPublisherApiObject;
};

/**
 * Component for displaying the list of invoices associated with a reminder
 *
 * Uses StoreDatatable to display invoices with pagination and sorting
 */
const ReminderHistory: React.FunctionComponent<ReminderHistoryProps> = function ({
    reminderPublisher,
}) {
    const theme = useTheme();

    console.log(theme);

    return (
        <Accordion
            sx={{
                marginBottom: 2,
                marginTop: 0,
                marginLeft: 2,
                marginRight: 2,
                width: '100hv',
                backgroundColor: 'background.paper',
            }}
            expanded={false}
            title={
                <Typography variant="l2dh6">
                    Envois :{' '}
                    <Typography
                        sx={{
                            marginLeft: 1,
                        }}
                        component="span"
                        color="text.gris70"
                    >
                        Ce rappel à été envoyé {reminderPublisher?.history?.length} fois
                    </Typography>
                </Typography>
            }
            expandLabel={<Typography variant="l2dsubtitles">Détails</Typography>}
        >
            <List>
                {reminderPublisher?.history?.map((hist) => (
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar>
                                <FaOptionIcon {...sendIcon.props} />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={`Le ${new Date(hist.sendDate as string).toLocaleDateString()} a ${new Date(hist.sendDate as string).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
                            secondary={
                                <Typography color="text.gris70">
                                    Identifiant du mail :{' '}
                                    <Typography
                                        color="text.gris35"
                                        component="span"
                                        variant="l2dcaption"
                                    >
                                        {hist.reminderMailId}
                                    </Typography>
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Accordion>
    );
};

export default ReminderHistory;
